// @flow

// TODO migrate everything to using illustrationColor in designSystem.js
// and then delete this file.

// 🚨 WARNING
// This is the old color palette as specified on https://design.mathspace.co/#/Colours
// The new color palette (which lacks names AFAICT) can be found here:
// https://www.lingoapp.com/92187/s/88C989C9-E691-40F7-9B1D-C21B1F431275/?v=0

const color = {
  // Primary colors
  ebony: '#0D0D21',
  astronaut: '#26276D',
  bayOfMany: '#2E3696',
  lochmara: '#0875BE',
  java: '#1CB7C8',
  mountainMeadow: '#1ABC9C',

  // Secondary colors
  purpleHeart: '#7547D8',
  cornflowerBlue: '#5758F7',
  genoa: '#0b5f4d',
  saffron: '#F4B42E',
  crusta: '#fd7b33',
  cinnabar: '#e74c3c',

  // Grays
  cloudBurst: '#21374D',
  pickledBluewood: '#34495E',
  nevada: '#606F74',
  santasGray: '#9A9DAB',
  iron: '#D4D7D9',
  blackHaze: '#e6e7e7',
  porcelain: '#F1F2F3',
  athensGrey: '#F9FAFB',
  shuttleGray: '#5E6D7F',

  // Accent colors
  iceberg: '#CAEFE7', // mountainMeadow accent
  tropicalBlue: '#D5E8F9', // lochmara accent
  snuff: '#E1E2F1', // astronaut, bayOfMany, lochmara accent
  provincialPink: '#FDEBE8', // cinnabar accent
  papayaWhip: '#FFECCF', // saffron accent
};

type Color = $Keys<typeof color>;

export type { Color };
export default color;
